import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppointmentRow, AppointmentTable} from "../../../lib/appointment-table";
import {AppointmentsService} from "../../../services/appointments.service";
import {MatTableModule} from '@angular/material/table';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {AgeSexPipe} from "../../../lib/age-sex.pipe";
import {OrgDatePipe} from '@allaihealth/ng-platform';
import {MatIconModule} from "@angular/material/icon";

/** Side navigation on patient pages where the user can switch to a different appointment */
@Component({
	selector: 'app-patient-side-nav',
	imports: [
		MatTableModule,
		AgeSexPipe,
		OrgDatePipe,
		MatIconModule,
		RouterLink,
		RouterLinkActive
	],
	templateUrl: './patient-side-nav.component.html',
	styleUrl: './patient-side-nav.component.scss'
})
export class PatientSideNavComponent implements OnInit, OnDestroy {
	/** Columns in the table */
	readonly displayedColumns:(keyof AppointmentRow | string)[] =
		['appointmentTime', 'patientName', 'status', 'actions'];

	/** Table control */
	private appointmentTable:AppointmentTable;

	constructor(private appointmentsService:AppointmentsService) {
	}

	ngOnInit() {
		this.appointmentTable = new AppointmentTable(this.appointmentsService);
		this.appointmentTable.connect();
	}

	ngOnDestroy() {
		this.appointmentTable.disconnect();
	}

	get dataSource() {
		return this.appointmentTable.dataSource;
	}
}
